.buttons {
  display: flex;
  flex-direction: column;
  // gap: 10px;
  button:first-of-type {
    margin-top: 0!important;
  }
  button {
    border-radius: 16px;
    height: 36px;
  }
}
